<!--
* @Description: In User Settings Edit
-->

<template>
  <v-row align="center" dense>
    <v-col cols="4">
      {{ title }}
      <span class="textKey" v-if="isKeyPoints">*</span>
      :
    </v-col>
    <v-col cols="6">
      <v-text-field
        v-model="value"
        :rules="rules"
        dense
        :type="isPass ? 'password' : 'text'"
        @change="chageValue"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import regular from '../utils/regular.js'
export default {
  name: 'inputView',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    isKeyPoints: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 1,
    },
    isPass: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    var vue = this
    return {
      rules: [],
      value: '',
    }
  },
  created() {},
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.value = this.label
      /**type
      类型1:字符
      类型2:邮箱地址
      类型3:纯数字
      **/
      if (this.maxLength != 0) {
        this.rules.push((v) => (v && v.length <= this.maxLength) || this.title + '字符长度不符')
      }
      if (this.isKeyPoints) {
        this.rules.push((v) => !!v || this.title + '不能为空')
      }
      if (this.type == 2) {
        this.rules.push((v) => regular.checkEmail(v) || '邮件格式错误')
      } else if (this.type == 3) {
        this.rules.push((v) => regular.checkNubmer(v) || '格式错误')
      }
    },

    chageValue() {
      this.$emit('changeValue', this.value)
    },
  },
}
</script>
<style></style>
